import * as $ from "jquery";
import * as Backbone from "backbone";
import * as Marionette from "backbone.marionette";
import * as _ from "underscore";
import { on, Options } from "../utils/decorators";


@Options({
    template: false,
    ui: {
        dateSelect: "[data-js-ui=dateSelect]",
    }
})
export default class PerformanceDetailView extends Marionette.View<Backbone.Model>{

    @on("change @ui.dateSelect")
    onDateSelectChange(e) {
        let $target = $(e.currentTarget);
        window.location.href = (<any>$target.val());
    }

    onRender() {
        if( $('.btn--buy-3rd-party-tickets').length || $('.not-for-sale').length || $('.btn--force').length ) {
            $('body').addClass('has-buy-button');
        }
    }
}



// WEBPACK FOOTER //
// ./@modules/views/performance-detail-view.ts